import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md/lib/free/modals';
import { Address, AddressType, SelectAddress } from 'src/app/shared-core/models/checkout-data.model';
import { CheckoutService } from 'src/app/shared-core/services/checkout.service';

@Component({
  selector: 'app-address-pick',
  templateUrl: './address-pick.component.html',
  styleUrls: ['./address-pick.component.scss'],
})
export class AddressPickComponent implements OnInit {
  @Input() addressType: AddressType;
  @Output() addressSelected = new EventEmitter<Address>();
  @ViewChild('selectAddressModal') selectAddressModal: ModalDirective;
  selectAddressModel: SelectAddress;
  isWaiting: boolean;
  constructor(private service: CheckoutService) {}

  ngOnInit(): void {}

  showAddresses(event: UIEvent) {
    this.isWaiting = true;
    this.selectAddressModal.show();
    event.preventDefault();
    this.service.getProfileAddresses(this.addressType).subscribe((r) => {
      this.isWaiting = false;
      this.selectAddressModel = r;
    });
  }

  selectAddress(address: Address) {
    this.service.useProfileAddress(this.addressType, address.AddressID).subscribe((r) => {
      this.addressSelected.emit(address);
    });
    this.selectAddressModal.hide();
  }
}
